<template>
<div class="">
    <el-tabs tab-position="top" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="General" name="first">
            <el-form ref="personRef" :model="person" :rules="rules" class="py-4 px-8">
                <h3 class="font-size-lg text-dark font-weight-bolder mb-6 border-bottom pb-4">Registro de datos personales:</h3>
                <div class="form-group row mb-0">
                    <div class="col-sm-4">
                        <label class="mb-0">Código</label>
                        <el-input :value="payroll.code" size="medium" :disabled="true">
                            <template slot="prepend">{{payroll.record_type}}</template>
                        </el-input>
                        <!--<el-form-item label="Código deportista" prop="idperson">
                            <el-input ref="idperson" v-model="person.idperson" size="medium"></el-input>
                        </el-form-item>-->
                    </div>
                    <div class="col-sm-8">
                        <el-form-item label="Tipo de documento" prop="docnumber">
                            <el-input placeholder="N° de documento*" v-model="person.docnumber" size="medium">
                                <el-select v-model="person.doctype" slot="prepend" :style="{width:'200px'}" placeholder="- Seleccione -" size="medium">
                                    <el-option v-for="item in tpodocs" :key="item.idmstdetails" :label="item.name" :value="item.idmstdetails"></el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group row mb-0">
                    <div class="col-sm-4">
                        <el-form-item prop="firstname" label="Nombres completos*" :rules="[{
                            required: true,
                            message: 'Falta ingresar nombres completos',
                            trigger: ['blur', 'change']
                        }]">
                            <el-input v-model="person.firstname" size="medium"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item prop="lastname" label="Apellido paterno*" :rules="[{
                            required: true,
                            message: 'Falta ingresar apellido paterno',
                            trigger: ['blur', 'change']
                        }]">
                            <el-input v-model="person.lastname" size="medium"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item prop="surname" label="Apellido materno*" :rules="[{
                            required: true,
                            message: 'Falta ingresar apellido materno',
                            trigger: ['blur', 'change']
                        }]">
                            <el-input v-model="person.surname" size="medium"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group row mb-0">
                    <div class="col-sm-4">
                        <el-form-item prop="gender" label="Sexo*" :rules="[{
                            required: true,
                            message: 'Falta seleccionar sexo',
                            trigger: 'change'
                        }]">
                            <el-radio-group v-model="person.gender" size="medium" class="w-100">
                                <el-radio v-for="(item, index) in gender" :key="index" :label="item.id">{{item.name}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item prop="marital_status" label="Estado civil*" :rules="[{
                            required: true,
                            message: 'Falta seleccionar estado civil',
                            change: 'change'
                        }]">
                            <el-select v-model="person.marital_status" placeholder="- Seleccione -" size="medium" class="w-100">
                                <el-option v-for="(item, index) in maritalStatus" :key="index" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item prop="birthday" label="Fecha nacimiento*" :rules="[{

                            required: true,
                            message: 'Falta seleccionar fecha nacimiento*',
                            change: ['blur', 'change']
                        }]">
                            <el-input v-model="person.birthday" size="medium" placeholder="yyyy-mm-dd">

                            </el-input>
                            <!--<el-date-picker placeholder="- Seleccione -" v-model="person.birthday" type="date" format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>-->

                        </el-form-item>
                    </div>
                </div>
            </el-form>

            <el-form ref="contactRef" :model="contact" class="py-4 px-8  d-none">
                <h3 class="font-size-lg text-dark font-weight-bolder mb-6 border-bottom pb-4">Registro de datos de contacto:</h3>
                <div class="form-group row mb-0">
                    <div class="col-sm-4">
                        <el-form-item prop="iddistrict" label="Ubigeo*" :rules="[{
                            required: true,
                            message: 'Falta seleccionar ubigeo',
                            change: ['blur', 'change']
                        }]">
                            <el-input v-model="contact.iddistrict" size="medium" :disabled="true">
                                <el-button type="warning" slot="append" icon="el-icon-search" plain @click="open_dialog_ubigeo = true"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="address" label="Domicilio actual*" :rules="[{
                            required: true,
                            message: 'Falta ingresar domicilio actual',
                            change: ['blur', 'change']
                        }]">
                            <el-input v-model="contact.address" size="medium"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Teléfono" prop="phone_number">
                            <el-input placeholder="N° de documento*" v-model="contact.phone_number" size="medium">
                                <el-select v-model="contact.phone_type" slot="prepend" :style="{width:'150px'}" placeholder="- Seleccione -" size="medium">
                                    <el-option v-for="item in phoneType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Email" prop="email">
                            <el-input v-model="contact.email" size="medium">
                                <template slot="prepend">@</template>
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>

            <el-form ref="payrollRef" :model="payroll" class="py-4 px-8">
                <h3 class="font-size-lg text-dark font-weight-bolder mb-6 border-bottom pb-4">Registro de datos adicionales:</h3>
                <div class="form-group row mb-0">
                    <div class="col-sm-4">
                        <el-form-item label="Ocupación" prop="ocupation">
                            <el-select v-model="payroll.ocupation" placeholder="- Seleccione -" size="medium" class="w-100">
                                <el-option v-for="(item, index) in occupations" :key="index" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Tipo de sangre" prop="blood_type">
                            <el-select v-model="payroll.blood_type" placeholder="- Seleccione -" size="medium" class="w-100">
                                <el-option v-for="(item, index) in bloodType" :key="index" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Estatura" prop="stature">
                            <el-input v-model="payroll.stature" size="medium">
                                <template slot="append">cm</template>
                            </el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="footer text-right">
                    <el-button v-if="payroll.idpayroll!=null" type="danger" @click="updatePerson">Actualizar</el-button>
                    <el-button v-else type="danger" :loading="loading" @click="savePerson" size="medium">Registrar</el-button>
                </div>

            </el-form>

        </el-tab-pane>

        <el-tab-pane label="Fotografía" :disabled="addedit" name="second">
            <div class="d-flex mb-4 justify-content-between">

               <span v-if="idphoto==null" class="border border-danger text-danger py-1 px-3 rounded h-30px">Fotografia no disponible</span>
                <span v-else class="border border-success text-success py-1 px-3 rounded h-30px">Fotografiano disponible</span>
                <el-upload class="upload-demo" :headers="headers" name="file" action="https://fdptkd.perufedup.com/api/photo/upload" accept=".jpg,.png" :data="payroll" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError" >
                    <el-button size="small" type="success" plain>{{(idphoto==null) ? 'Clic para subir archivo' : 'Clic para actualizar archivo'}}</el-button>
                </el-upload>

            </div>

            <el-alert title="Foto Tipo CARNET a color en fondo blanco, solo archivos jpg/png con un tamaño menor de 1MB" type="info" :closable="false">
            </el-alert>
            <div class="row justify-content-center">
                <el-image v-if="idphoto!=null" :src="photo.ruta" class="my-4 h-250px">
                    <div slot="placeholder" class="image-slot">
                        cargando<span class="dot">...</span>
                    </div>
                </el-image>
            </div>

        </el-tab-pane>

        

        <!--<el-tab-pane label="Documentos de Identidad" :disabled="addedit" name="third">Documentos de identidad</el-tab-pane>-->

        <!--<el-tab-pane label="Datos de contacto" name="3" :disabled="false">Datos de contacto</el-tab-pane>-->
        <!--<el-tab-pane label="Datos adicionales" name="4" :disabled="false">-->
        <!--start Datos adicionales-->
        <!--<div class="row p-4">-->
        <!--<el-form ref="ruleFormRef" :model="form1" :rules="rules" label-width="200px">
                    <el-form-item label="Ocupación" prop="marital_status">
                        <el-select v-model="form1.marital_status" placeholder="Seleccione" size="medium">
                            <el-option v-for="(item, index) in maritalStatus" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Tipo de sangre" prop="marital_status">
                        <el-select v-model="form1.marital_status" placeholder="Seleccione" size="medium">
                            <el-option v-for="(item, index) in maritalStatus" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Estatura" prop="marital_status">
                        <el-input v-model="form1.place_birthday" placeholder="Estatura en cm" size="medium"></el-input>
                    </el-form-item>
                </el-form>-->
        <!--</div>-->
        <!--End Datos adicionales-->
        <!--</el-tab-pane>-->
        <!--<el-tab-pane label="Registro de padres o tutores" :disabled="addedit" name="fourth">
        
        </el-tab-pane>-->
    </el-tabs>
    <DialogUbigeo :visible.sync="open_dialog_ubigeo"></DialogUbigeo>
</div>
</template>

<script>
import data from "@/data/common"
import code from "@/core/config/error";

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

//components
import DialogUbigeo from "@/components/DialogUbigeo"

//services
import payrollService from "@/core/services/payroll.service"
import JwtService from "@/core/services/jwt.service";
import photoService from "@/core/services/photo.service"
//import personService from "@/core/services/person.service"

import {
    mapGetters
} from "vuex";

export default {
    props: {
        info: {
            type: Object,
            required: true,
            default: {}
        },
        addedit: {
            type: Boolean,
            required: true,
            default: true
        },
        record_type: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        DialogUbigeo
    },
    data: () => ({
        activeName: 'first',
        payroll: {},
        person: {},
        contact: {},
        rules: {},
        gender: data.gender,
        open_dialog_ubigeo: false,
        loading: false,
        idphoto: null,
        photo: {},
        headers: {
            Authorization: `Bearer ${JwtService.getToken()}`
        }
    }),
    computed: {
        ...mapGetters(['maritalStatus', 'tpodocs', 'phoneType', 'bloodType', 'occupations']),
    },
    methods: {
        savePerson() {
            this.$refs['personRef'].validate(async (valid) => {
                if (!valid)
                    return false;

                try {
                    //validar si aun esta disponible
                    this.loading = true
                    const res1 = await payrollService.searchPerson(this.person)
                    if (res1.data.existe) {
                        this.loading = false
                        return this.$alert(res1.data.message, 'Alerta', {
                            type: 'error',
                            dangerouslyUseHTMLString: true
                        })
                    }

                    //alert(this.person.idperson)
                    //if hay idperson, actualizamo, sino guardamos todo :/
                    if (this.person.idperson != null && this.person.idperson != 'undefined') {
                        this.payroll.record_type = this.record_type
                        const ps = await payrollService.update({
                            person: this.person,
                            contact: this.contact,
                            payroll: this.payroll
                        })
                        this.person = ps.data.person
                        this.payroll = ps.data.payroll
                        this.loading = false
                        this.$emit("onAddEdit", ps.data);

                    } else {
                        this.payroll.record_type = this.record_type
                        const ps = await payrollService.save({
                            person: this.person,
                            contact: this.contact,
                            payroll: this.payroll
                        })
                        this.person = ps.data.person
                        this.payroll = ps.data.payroll
                        this.loading = false
                        this.$emit("onAddEdit", ps.data);
                    }
                } catch (error) {
                    this.loading = false
                    code.Manager(error.response)
                }

            })

            /*this.$refs['payrollRef'].validate( (valid) => {
                if (!valid)
                    return false;

                alert()

            })*/
            //validar si aun no ha sido tomado por otra institución
            /*this.$emit("onAddEdit", {
                addedit: false
            });*/
        },
        updatePerson() {

        },
        openDialogUbigeo() {
            //alert()
        },
        handleClick(tab, event) {
            //console.log(this.activeName)
            //console.log(tab, event);
            if(this.activeName == 'second')
                this.loadPhotos()
        },
         async loadPhotos() {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            console.log(this.payroll)
            await photoService.get(this.payroll).then((res) => {
                if (res.data != null) {
                    this.photo = res.data
                    this.idphoto = this.photo.idphoto
                }
            }).catch((error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(error.response)
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        handleAvatarSuccess(res, file) {
            this.$message({
                message: res.message,
                type: 'success'
            })
            this.loadPhotos()
        },
        handleAvatarError(err, file) {
            const e = JSON.parse(err.message);
            this.$alert(e.messages.error, 'Error ' + e.error, {
                type: 'warning'
            });
        },
        beforeAvatarUpload(file) {
            const isIMAGE = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg');

            if (!isIMAGE) {
                this.$message.error('Formato de Imágen no admitido!');
                return false;
            }
            return true;
        }
    },
    created() {
        console.log(this.record_type)
        if (this.info.data != null)
            this.payroll = this.info.data
        if (this.info.person != null)
            this.person = this.info.person
        else {
            this.person.record_type = this.record_type
            this.person.doctype = '1'
        }

        //console.log(this.person)

    }
}
</script>
